import CronTasksExEdit from './CronTasksExEdit';
import WebUniversal, { WUExtendPropsType } from '../WebUniversalNewEx'
import { columnsheadId } from '../../universal/columnshead';
import dayjs from 'dayjs';
import { Switch, Tooltip } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import { useEffect, useRef, useState } from 'react';
import antMessage from '../../../utils/extend/AntdNotification';

const CronJob = (props: any) => {
    /** api服务id */
    const apiId = 'cronTasksEx';
    const ref = useRef<any>(undefined);
    /** 后端数据defaultService */
    const [defaultService, setDefaultService] = useState<any>('');
    /** 刷新 */
    const [initData, setInitData] = useState<any>();

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setDefaultService(urlService)
            setInitData(ref.current.initData);
        }
        //同步获取数据 async - await
        const fetchData = async () => {
            // const res = await fetchApi.GET(defaultService,
            //     {
            //         apiId: 'configs',
            //         apiVariable: 'system',
            //         apiExtend: 'getNodeValue',
            //         apiData: {
            //             nodeId: 'companyFilePath',
            //             privatePar: false
            //         }
            //     });
        }
        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据
    //表头
    const columnsHead = [
        {
            title: '任务名',
            dataIndex: 'taskName',
        },
        {
            title: '类型',
            dataIndex: 'taskType',
            render: (val: any) => val?.name
        },
        {
            title: '作业',
            dataIndex: 'job',
            sorter: true,
            render: (val: any) => val?.jobName
        },
        {
            title: '定时方式',
            dataIndex: 'expression',
            render: (text: any) => <Tooltip placement="top" title={'使用 ( * * * * * * ) 秒：0-59；分钟：0-59；小时：0-23；天：1-31；月份：0-11（1月至12月）；星期几：0-6（周日至周六）；' +
                '提示 (*)为通配符；(-)为时间段连接符；(,)号为分隔符，可以在某一节输入多个值；(/)号为步进符；' +
                '例子：(1 * * * * *)：每分钟第一秒执行；(*/3 * * * * *)：间隔3秒执行;'}>
                {text}
            </Tooltip>,
        },
        {
            title: '开始时间',
            dataIndex: 'startDate',
            sorter: true,
            render: (val: dayjs.ManipulateType, record: any) =>
                <span>
                    {dayjs(val).format('YYYY-MM-DD HH:mm:ss')}
                </span>,
        },
        {
            title: '结束时间',
            dataIndex: 'endDate',
            sorter: true,
            render: (val: dayjs.ManipulateType, record: any) =>
                <span>
                    {dayjs(val).format('YYYY-MM-DD HH:mm:ss')}
                </span>,
        },
        {
            title: '模式',
            dataIndex: 'taskMode',
            render: (val: any) => val?.name
        },
        {
            title: '已执行/总数',
            dataIndex: 'exeCount',
            render: (val: any, record: any) => `${val}/${record?.totalCount}`
        },
        {
            title: '流程',
            dataIndex: 'taskProcess',
            render: (val: any, record: any) => {
                let color;
                switch (val?.id) {
                    case -1:
                        color = 'red';
                        break;
                    case 1:
                        color = 'yellow';
                        break;
                    case 2:
                        color = 'green';
                        break;
                    default:
                        color = 'white';
                        break;
                }
                return (<>
                    <Tooltip placement="top"
                        title={`最后执行时间：${dayjs(record.lastExeDate).format('YYYY-MM-DD HH:mm:ss')}`}>
                        <text style={{ color }}> {val?.name}</text>
                    </Tooltip></>)
            }
        },
        {
            title: '成功',
            dataIndex: 'isExeReturnSuccess',
            render: (text: any, record: any) => (
                <Tooltip placement="top" title={'任务执行成功后为：true，失败为：false'}>
                    <Switch checkedChildren="是" unCheckedChildren="否"
                        checked={text} key={record.id}
                    />
                </Tooltip>
            )
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '定时任务',
        apiId,
        columns,
        showStates: true,
        pagination: true,
        EditComponent: CronTasksExEdit,
        showLogger: {
            loggerSingleDisplay: true,
            logType: { id: 'SYSTEM' }
        },
    };

    return (
        <>
            <WebUniversal props={extendProps} ref={ref} />
        </>
    )
}

export default CronJob;
